var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.16667C11.8473 4.16667 13.0844 4.62794 14.0719 5.39505L17.1029 2.50341C15.3407 0.949961 13.0339 0 10.5 0C6.66034 0 3.33057 2.1666 1.65485 5.34154L5.02521 8.00232C5.84165 5.76614 7.98124 4.16667 10.5 4.16667Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4134 11.2519C20.4655 10.8422 20.5 10.4242 20.5 10.0003C20.5 9.28545 20.4219 8.58935 20.2794 7.91699H10.5V12.0837H15.9052C15.4679 13.2201 14.6894 14.1818 13.6983 14.8499L17.0812 17.5206C18.8745 15.9465 20.1016 13.7423 20.4134 11.2519Z",
    fill: "#2196F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 10.0003C4.66667 9.29738 4.79738 8.62661 5.0252 8.00257L1.65484 5.3418C0.920278 6.7336 0.5 8.31706 0.5 10.0003C0.5 11.6646 0.912547 13.2305 1.63185 14.6111L5.00648 11.9469C4.79036 11.3373 4.66667 10.6839 4.66667 10.0003Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.833C7.96207 15.833 5.8087 14.2093 5.00649 11.9463L1.63186 14.6105C3.29939 17.8109 6.64152 19.9997 10.5 19.9997C13.0232 19.9997 15.324 19.0623 17.0812 17.5199L13.6984 14.8492C12.7844 15.4654 11.6903 15.833 10.5 15.833Z",
    fill: "#00B060"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.5 19.7915C7.55693 19.7915 4.91059 18.5772 3.03961 16.6426C4.87112 18.698 7.53038 19.9998 10.5 19.9998C13.4421 19.9998 16.0794 18.7237 17.9068 16.7005C16.0413 18.6037 13.4151 19.7915 10.5 19.7915Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.5 11.875V12.0833H15.9052L15.9896 11.875H10.5Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4954 10.1229C20.496 10.0818 20.5 10.0415 20.5 10.0004C20.5 9.98871 20.4982 9.97747 20.4981 9.96582C20.4976 10.0183 20.4949 10.0702 20.4954 10.1229Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.5 7.91699V8.12533H20.3213C20.3082 8.05656 20.2939 7.98525 20.2794 7.91699H10.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2794 7.91667H10.5V12.0833H15.9052C15.0646 14.268 12.981 15.8333 10.5 15.8333C7.27836 15.8333 4.66667 13.2216 4.66667 10C4.66667 6.77831 7.27836 4.16667 10.5 4.16667C11.6682 4.16667 12.7449 4.52555 13.6571 5.11724C13.7967 5.20798 13.9408 5.29317 14.0719 5.39505L17.1029 2.50341L17.0345 2.45082C15.2808 0.930888 13.0029 0 10.5 0C4.97713 0 0.5 4.47713 0.5 10C0.5 15.5228 4.97713 20 10.5 20C15.5981 20 19.7962 16.1823 20.4134 11.2515C20.4655 10.8418 20.5 10.4239 20.5 10C20.5 9.28513 20.4219 8.58902 20.2794 7.91667Z",
    fill: "url(#paint0_linear_269_9732)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.6571 4.9094C12.7449 4.31772 11.6682 3.95883 10.5 3.95883C7.27836 3.95883 4.66667 6.57048 4.66667 9.79217C4.66667 9.82731 4.66714 9.85478 4.66775 9.88982C4.72395 6.71676 7.31351 4.16717 10.5 4.16717C11.6682 4.16717 12.7449 4.52605 13.6571 5.11774C13.7967 5.20848 13.9408 5.29367 14.0719 5.39555L17.1029 2.50391L14.0719 5.18722C13.9408 5.08534 13.7967 5.00014 13.6571 4.9094Z",
    fill: "#222222"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.5 0.208333C12.9792 0.208333 15.2358 1.12366 16.9827 2.618L17.1029 2.50341L17.0112 2.42356C15.2575 0.903633 13.0029 0 10.5 0C4.97713 0 0.5 4.47713 0.5 10C0.5 10.0351 0.504883 10.0691 0.505239 10.1042C0.561696 4.62987 5.01228 0.208333 10.5 0.208333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_9732",
    x1: 0.5,
    y1: 10,
    x2: 20.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.fa1ca1b5ee481fca3ea527b0de437d51.svg";
export { ForwardRef as ReactComponent };